// extracted by mini-css-extract-plugin
module.exports = {"modalProfileMenu":"styles_modalProfileMenu__jPZJo"};